<template>
  <div
    class="insider-notifications"
    @mouseover="stopTheTimer()"
    @mouseleave="startTheTimer()"
  >
    <div class="insider-notifications__container">
      <button
        class="insider-notifications__navigation-button"
        @click="showPrevious()"
      >
        <IconArrowPrevious />
      </button>
      <div
        v-if="currentNotification"
        name="notification-list"
        class="insider-notifications__list"
      >
        <article class="insider-notifications__card">
          <div class="insider-notifications__card-content">
            <h3 class="insider-notifications__card-title">
              {{ currentNotification.name }}
            </h3>
            <p
              v-html="currentNotification.description"
              class="insider-notifications__card-description"
            />
            <div class="insider-notifications__card-button">
              <BaseButton @click="goTo(currentNotification.button_url)">
                {{ currentNotification.button_name }}
              </BaseButton>
            </div>
          </div>
        </article>
      </div>
      <button
        class="insider-notifications__navigation-button"
        @click="showNext()"
      >
        <IconArrowNext />
      </button>
    </div>
  </div>
</template>

<script>
  import IconArrowPrevious from '~/components/icon/IconArrowPrevious';
  import IconArrowNext from '~/components/icon/IconArrowNext';
  import BaseButton from '~/components/base/BaseButton.vue';

  export default {
    name: 'InsiderNotifications',
    components: {
      IconArrowPrevious,
      IconArrowNext,
      BaseButton,
    },
    props: {
      notifications: {
        type: Array,
        required: true,
      },
    },
    data: () => ({
      selectedNotificationId: 0,
      timer: null,
    }),
    computed: {
      currentNotification() {
        return this.notifications[this.selectedNotificationId];
      },
    },
    created() {
      this.startTheTimer();
    },
    methods: {
      showPrevious() {
        if (this.selectedNotificationId === 0) {
          this.selectedNotificationId = this.notifications.length - 1;
        } else {
          this.selectedNotificationId--;
        }
      },
      showNext() {
        if (this.selectedNotificationId === this.notifications.length - 1) {
          this.selectedNotificationId = 0;
        } else {
          this.selectedNotificationId++;
        }
      },
      goTo(url) {
        window.open(url, '_blank');
      },
      startTheTimer() {
        this.timer = setInterval(() => {
          this.showNext();
        }, 7000);
      },
      stopTheTimer() {
        clearInterval(this.timer);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .insider-notifications {
    flex: 1 auto;
    position: relative;
    width: 100%;
    height: 133px;
    z-index: 0;
    margin: 20px;
    @include screen-lg {
      height: 184px;
    }
    @include screen-xl {
      width: 60%;
    }
    &::before {
      content: '';
      position: absolute;
      top: -10px;
      left: -10px;
      width: 100%;
      height: 100%;
      background-color: var(--itr-green);
      border-radius: 10px;
      z-index: -1;
    }

    &::after {
      content: '';
      position: absolute;
      bottom: -10px;
      right: -10px;
      width: 100%;
      height: 100%;
      background-color: var(--itr-blue);
      border-radius: 10px;
      z-index: -1;
    }

    &__list {
      display: flex;
      min-height: 135px;
      // width: 100%;
      height: 100%;
    }

    &__container {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      width: 100%;
      height: 100%;
      overflow: hidden;
      padding-left: 10px;
      padding-right: 10px;

      border: 4px solid var(--itr-white);
      border-radius: 10px;
      background: linear-gradient(95deg, #d9d9d9 12.68%, #f0f1f1 85.02%);
    }

    &__card {
      padding: 10px;
      max-height: 192px;
      overflow: hidden;
      @include screen-lg {
        padding: 20px 10px;
      }
    }

    &__card-content {
      display: grid;
      gap: 5px;
      grid-template-rows: 1fr 1fr;
      grid-template-columns: repeat(12, 1fr);
      height: 100%;

      @include screen-sm {
        grid-template-rows: 1fr;
        grid-template-columns: repeat(12, 1fr);
        align-items: center;
      }
      @include screen-md {
        grid-template-rows: auto auto;
        align-items: start;
      }
      @include screen-lg {
        grid-template-rows: 55px auto;
        align-items: start;
      }
    }

    &__card-title {
      font-size: 18px;
      font-weight: 900;
      margin: 8px 0;
      color: var(--itr-blue);
      grid-row: 1;
      grid-column: 1 / span 12;
      @include screen-sm {
        grid-column: 1 / span 10;
      }
      @include screen-md {
        font-size: 24px;
        line-height: 24px;
        grid-row: 1;
        grid-column: 1 / span 12;
      }
    }

    &__card-description {
      // flex: 1 auto;
      font-size: 14px;
      font-weight: 400;
      color: #000;
      width: 100%;
      height: 100%;
      display: none;
      max-height: 130px;
      @include screen-md {
        display: inline;
        grid-row: 2;
        grid-column: 1 / span 11;
        width: 95%;
      }
    }

    &__card-button {
      height: fit-content;
      width: fit-content;
      grid-row: 2;
      grid-column: 1 / span 12;
      margin: auto;
      @include screen-sm {
        grid-row: 1;
        grid-column: 12;
        margin: unset;
      }
      @include screen-md {
        grid-row: 2;
        grid-column: 12;
      }
    }

    &__navigation-button {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--itr-grey-mid);
      border: 1px solid var(--itr-white);
      border-radius: 5px;
      cursor: pointer;
      padding: 0;
      margin: 0;

      transition: background-color 0.3s ease-in-out;

      &:hover {
        background-color: #818181;
        transition: background-color 0.3s ease-in-out;
      }
    }
  }

  .notification-list {
    position: relative;
    height: 100%;
  }
</style>
